export default __webpack_public_path__ + "static/media/landing-sec-bg.9d333c0a.png";